import { useCallback, useMemo } from "react"

import { UseTableRowSelectionProps, UseTableRowSelectionRes } from "./types"

export function useTableRowSelection<T>({
  data,
  state,
  dispatch,
}: UseTableRowSelectionProps<T>): UseTableRowSelectionRes<T> {
  const select = useCallback<UseTableRowSelectionRes<T>["select"]>(
    (dataToSelect: T[]) => {
      dispatch({
        type: "select_rows",
        rowData: dataToSelect,
      })
    },
    [dispatch]
  )

  const toggleSelected = useCallback<
    UseTableRowSelectionRes<T>["toggleSelected"]
  >(
    (rowData: T) => {
      dispatch({ type: "toggle_row_selected", rowData, visibleRowData: data })
    },
    [dispatch, data]
  )

  const toggleAllSelected = useCallback<
    UseTableRowSelectionRes<T>["toggleAllSelected"]
  >(() => {
    dispatch({ type: "toggle_all_selected" })
  }, [dispatch])

  const clearSelected = useCallback<
    UseTableRowSelectionRes<T>["clearSelected"]
  >(() => {
    dispatch({ type: "clear_selected" })
  }, [dispatch])

  const selected = useMemo<UseTableRowSelectionRes<T>["selected"]>(
    () => Array.from(state.selectedByKey.values()),
    [state.selectedByKey]
  )

  return {
    isAllSelected: state.isAllSelected,
    selected,
    select,
    toggleSelected,
    toggleAllSelected,
    clearSelected,
  }
}
